import React from 'react';
import ReactWOW from 'react-wow';

// import Countdown, { doubleDigit } from 'react-downcount';
import { $t } from '@/modules/i18n';

import ultraHackLogo from '@uh/assets/images/ultra_hack_logo.png';
import leftArrowOutline from '@uh/assets/images/leftArrowOutline.png';
import leftArrowSolid from '@uh/assets/images/leftArrowSolid.png';
import rightArrowSolid from '@uh/assets/images/rightArrowSolid.png';
import rightArrowOutlineWhite from '@uh/assets/images/rightArrowOutlineWhite.png';


// const endDate = '';

// const clockRenderer = ({ days, hrs, mins, secs, isCompleted }) => {
//   return isCompleted
//     ? ''
//     : <React.Fragment>
//       <div className="segment">
//         <span className="number">{days}</span>
//         <span className="unit">{days > 1 ? 'days': 'day'}</span>
//       </div>
//       <div className="segment">
//         <span className="number">{hrs}</span>
//         <span className="unit">{hrs > 1 ? 'hours' : 'hour'}</span>
//       </div>
//       <div className="segment">
//         <span className="number">{doubleDigit(mins)}</span>
//         <span className="unit">{mins > 1 ? 'mins' : 'min'}</span>
//       </div>
//       <div className="segment">
//         <span className="number">{doubleDigit(secs)}</span>
//         <span className="unit">{secs > 1? 'secs' : 'sec'}</span>
//       </div>
//     </React.Fragment>
// }


class Hero extends React.Component {
  goRegister() {
    // const target = document.getElementById("register");
    // target.scrollIntoView({ block: 'start', behavior: 'smooth' });
    window.open("https://techatshopee.formstack.com/forms/shopee_ultrahackathon_2021")
  }

  render() {
    const msg = this.props.Message;
    return (
      <section id="hero">
        <div className="container">
          <img src={ultraHackLogo} alt="Shopee Ultra-Hackathon 2021 [logo]" className="hero-image" />
          <div className="hero-textContent">
            <ReactWOW animation="fadeInUp" delay="0.1s">
              <h1 className={msg.dateRange ? "date" : "noDate"}>
                {
                  msg.dateRange ? (<React.Fragment>{msg.dateRange}< br />{$t(msg.heroDesc)} </React.Fragment>) : (<React.Fragment>{$t(msg.heroDesc)}<br /></React.Fragment>)
                }
              </h1>
              <p className="start">{msg.heroClockSubtitle}</p>
              {/* <button title={$t(msg.registerNow)} onClick={this.goRegister} className="btn btn-primary">{$t(msg.registerNow)}</button> */}
              <div className="subtitle">{$t(msg.heroSubtitle)}</div>
            </ReactWOW>
          </div>
          <img src={leftArrowOutline} alt="arrowGraphic" className="left-arrow-large" />
          <img src={leftArrowSolid} alt="arrowGraphic" className="left-arrow-small" />
        </div>
        <img src={rightArrowSolid} alt="arrowGraphic" className="right-arrow-large" />
        <img src={rightArrowOutlineWhite} alt="arrowGraphic" className="right-arrow-small" />
      </section>
    )
  }
};

export default Hero;
